/* eslint-disable import/prefer-default-export */

import PropTypes from 'prop-types';
import { validationStatusCodes } from '../components/ValidationStatus/ValidationStatusCodes';

export const validationStatusPropType = PropTypes.oneOf(Object.values(validationStatusCodes));
